import { Collapse } from 'antd-v5';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/i18n';

export default function TNC() {
    const { t } = useLang('dpux.TNC');
    const { locale = 'us' } = getLocal();

    const tnc_count = {
        ca: 3,
        us: 4,
    };

    const lists: any[] = Array.from({ length: tnc_count?.[locale] || 3 }).map((_, i) => ({
        title: t(`title${i + 1}`),
        desc: t(`desc${i + 1}`),
    }));

    return (
        <section
            className={`delta-pro-ultra-x-TNC ${css.section}`}
            id="delta-pro-ultra-x-TNC"
            data-section-id={'delta-pro-ultra-x-TNC'}
            data-section-title={t('title')}
        >
            <Collapse
                ghost={true}
                className="collapse-lists"
                expandIcon={({ isActive }: any) => {
                    return (
                        <svg
                            className={`collapse-icon ${isActive ? 'active' : ''}`}
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 25 24"
                            fill="none"
                        >
                            <path d="M17.5 15L12.5 10L7.5 15" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    );
                }}
                expandIconPosition="right"
                defaultActiveKey={0}
            >
                {lists.map((list: any, k: number) => (
                    <Collapse.Panel className="list-title" key={k} header={list.title}>
                        <p className="list-desc">{list.desc}</p>
                    </Collapse.Panel>
                ))}
            </Collapse>
        </section>
    );
}
